export enum UserType {
  PRIVATE,
  COMPANY,
}
